module.exports = __webpack_public_path__ + "img/icon_vod_comment.64f39111.svg";